<template>
        <div v-if="items.length">
          <div v-for="item in items" :key="item.id" style="overflow:auto">
              <table>
                  <thead>
                    <tr>
                      <th colspan="3">
                        <h2>{{ item.title }}</h2>
                        <h3>{{ item.eventLocation }}, {{ item.startDate | asDate }}</h3>
                      </th>
                    </tr>
                    <tr>
                      <th>Title</th>
                      <th>Author</th>
                      <th>Download</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="block in item.eventDetails" :key="block.id">
                      <td style="width:45%" v-if="block.typeHandle == 'paperPresentation'">{{ block.libraryTitle }}</td>
                      <td style="width:45%" v-if="block.typeHandle == 'paperPresentation'" >{{ block.libraryAuthors }}</td>
                      <td style="width:10%" v-if="block.typeHandle == 'paperPresentation'">
                          <span v-if="block.libraryAttachment && block.libraryAttachment.length">
                              <strong><a :href="block.libraryAttachment[0].url" target="_blank" style="color:black">PDF</a></strong>
                          </span>
                      </td>
                      <td colspan="3" v-else>
                        <strong>{{ block.sectionHeader }}</strong><br>
                        {{ block.headerContent }}
                      </td>
                    </tr>
                  </tbody>
              </table>
          </div>
        </div>
        <div v-else>
            <div class="noMatchingItems" v-if="!loading">
              <p class="text-center">Sorry, no items match your selection.</p>
            </div>
        </div>

</template>

<script>

import { DateTime } from 'luxon';

export default {
    props:['items','loading'],
    filters: {
      asDate(value) {
        return DateTime.fromISO(value).toFormat('MMM yyyy');
      },
    }
  }
</script>